//node_modules
import React, { FunctionComponent } from "react";
import NextImage from "next/image";

type MentionImageComponentProps = {
  src: string;
};

const MentionImageComponent: FunctionComponent<MentionImageComponentProps> = ({ src }) => {
  return <NextImage src={src} alt="" fill unoptimized />;
};

export default React.memo(MentionImageComponent);
